import React from "react";
import { checkedCircleIcon } from "../../../common/checkedCircleIcon";
import { cancelIconRed } from "../../../common/cancelIconRed";

export const checkOrX = (bool: boolean) => {
  if (bool) {
    return checkedCircleIcon;
  } else return cancelIconRed;
};
